export default {
  seo: {
    home: {
      title: 'Artemida Studio — Kreatywne rozwiązania cyfrowe',
      description:
        'Tworzymy na zamówienie strony internetowe o dowolnej złożoności: strony docelowe (landing page), witryny korporacyjne oraz asystentów AI.',
      keywords:
        'tworzenie stron www, strona docelowa, witryna korporacyjna, AI',
    },
    // 🔽 nowe: SEO dla listy bloga
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Artykuły o tworzeniu stron WWW, designie, asystentach AI oraz budowaniu nowoczesnych serwisów firmowych.',
      keywords: 'blog, tworzenie stron www, design, ai, strony internetowe',
    },
  },

  header: {
    homeLink: 'Strona główna',
    aboutUsLink: 'O nas',
    servicesLink: 'Usługi',
    ourProjectsLink: 'Nasze projekty',
    contact: 'Kontakt',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription:
      'Tworzymy na zamówienie strony internetowe o dowolnej złożoności',
    contactUs: 'Skontaktuj się z nami',
  },
  aboutUsSection: {
    aboutUsTitle: 'O nas',
    aboutUsDescription:
      'W Artemida Studio specjalizujemy się w tworzeniu spersonalizowanych stron docelowych (landing page) i serwisów korporacyjnych, które pomagają firmom budować silną obecność w sieci. Naszą misją jest dostarczanie nowoczesnych, funkcjonalnych i wizualnie efektownych rozwiązań dopasowanych do potrzeb Twojej marki.\n\n' +
      'Łącząc kreatywność, najnowsze technologie oraz indywidualne podejście, tworzymy witryny, które są nie tylko estetyczne, ale także szybkie, przyjazne użytkownikom i w pełni responsywne.\n\n' +
      'Niezależnie od tego, czy potrzebujesz wysoko konwertującej strony docelowej, czy profesjonalnej witryny firmowej, Artemida Studio pomoże urzeczywistnić Twoją wizję dzięki rozwiązaniom szytym na miarę, najwyższej jakości.\n\n' +
      'Postaw na profesjonalizm i kreatywność — zbudujmy razem Twoją idealną stronę!',
  },

  // Usługi (cała sekcja sterowana przez i18n)
  services: {
    ourServices: 'Nasze usługi',
    servicesDescription:
      'Specjalizujemy się w tworzeniu wysokiej jakości, szytych na miarę rozwiązań cyfrowych, które rozwijają Twój biznes',
    contactUs: 'Skontaktuj się z nami',
    items: [
      {
        key: 'landing',
        title: 'Strona \n docelowa',
        descriptionList: [
          'Dobrze zaprojektowana strona docelowa to potężne narzędzie do przyciągania klientów, zwiększania konwersji i budowania widoczności marki online. W Artemida Studio tworzymy wysokiej jakości, spersonalizowane strony docelowe dopasowane do celów Twojej firmy.',
          '✔️ Nowoczesny i unikalny design — Wizualnie przyciągające, spójne z marką strony, które zwracają uwagę.',
          '✔️ Wysoka konwersja — Optymalny układ i przekonujące CTA zwiększające zaangażowanie.',
          '✔️ Szybkość i responsywność — Błyskawiczne działanie i płynne doświadczenie na wszystkich urządzeniach.',
          '✔️ Przygotowane pod SEO i marketing — Zbudowane zgodnie z dobrymi praktykami, by zwiększać widoczność i ruch organiczny.',
          '✔️ W pełni konfigurowalne — Każdy detal dopasowany do Twoich potrzeb i tożsamości marki.',
        ],
      },
      {
        key: 'corporate',
        title: 'Witryna \n firmowa',
        descriptionList: [
          'Profesjonalna witryna firmowa jest kluczowa, aby budować wiarygodność, prezentować markę i angażować klientów. W Artemida Studio tworzymy strony firmowe na miarę, które odzwierciedlają wartości Twojej firmy i wyróżniają Cię w świecie cyfrowym.',
          '✔️ Profesjonalny i unikalny design — Nowoczesny, dopracowany wygląd dopasowany do tożsamości marki.',
          '✔️ W pełni dopasowana — Każdy element projektowany pod Twoje cele biznesowe.',
          '✔️ Szybka i bezpieczna — Optymalizowana pod kątem prędkości, bezpieczeństwa i niezawodności.',
          '✔️ Przyjazna SEO i marketingowi — Zbudowana zgodnie z najlepszymi praktykami, aby zwiększać widoczność online i pozyskiwać leady.',
          '✔️ Mobilna i przyjazna użytkownikom — W pełni responsywny design dla spójnego doświadczenia na wszystkich urządzeniach.',
          '✔️ Proste zarządzanie treścią — Łatwe i szybkie aktualizacje dzięki intuicyjnemu CMS.',
        ],
      },
      {
        key: 'ai',
        title: 'Integracja asystentów AI',
        descriptionList: [
          'Wzmocnij swoją stronę mocą AI! W Artemida Studio integrujemy zaawansowanych asystentów AI, którzy poprawiają doświadczenie użytkownika, automatyzują zadania i zwiększają zaangażowanie. Niezależnie od tego, czy potrzebujesz inteligentnego chatbota, automatycznego wsparcia, czy rekomendacji opartych na AI — tworzymy rozwiązania dopasowane do Twojego biznesu.',
          '✔️ Wsparcie klienta 24/7 — Chatboty oparte na AI obsługują zapytania o każdej porze, zwiększając satysfakcję.',
          '✔️ Płynna integracja ze stroną — Działa bezproblemowo w Twoim serwisie, rozszerzając funkcjonalność bez zakłóceń.',
          '✔️ Spersonalizowane doświadczenie — Interakcje oparte na AI dopasowane do potrzeb i preferencji użytkownika.',
          '✔️ Generowanie leadów i wzrost sprzedaży — Angażuj odwiedzających, zbieraj kontakty i prowadź klientów do zakupu.',
          '✔️ Automatyzacja i efektywność — Usprawniaj procesy, zmniejszaj obciążenie i skracaj czas reakcji.',
          '✔️ Dedykowane rozwiązania AI — W pełni dopasowane do Twojego modelu biznesowego i specyficznych wymagań.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Porozmawiajmy o Twoim projekcie',
    placeholderName: 'Imię',
    placeholderPhone: 'Telefon',
    placeholderEmail: 'E-mail',
    placeholderMessage: 'Opowiedz nam o swoim projekcie',
    sendButton: 'Wyślij',
  },
};
